// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    additionalFilterOptions: Partial<Sys.Types.FindOptionsWhere<This.GoalSetting>>;
    allCycles: This.GoalSettingCycle[];
    linkToScreen: 'Edit' | 'View';
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-GoalSettingsListInclude',
    templateUrl: './GoalSettingsListInclude.html',
    styleUrls: ['./GoalSettingsListInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GoalSettingsListInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.GoalSettingsListInclude';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    _DataTableBlock_columns_68 = (screen: Properties) => ['id', 'cycle.startDate', 'employee.name', 'manager.name', 'status$id'];
    $validators: Record<number, ValidationRules> = {

    };
    input_additionalFilterOptions = input(undefined, { alias: 'additionalFilterOptions' });
    var_additionalFilterOptions = proxySignal<Partial<Sys.Types.FindOptionsWhere<This.GoalSetting>>>(undefined as any);
    var_allCycles = proxySignal<This.GoalSettingCycle[]>(undefined as any);
    input_linkToScreen = input(undefined, { alias: 'linkToScreen' });
    var_linkToScreen = proxySignal<'Edit' | 'View'>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get additionalFilterOptions() { return component.var_additionalFilterOptions() },
                set additionalFilterOptions(value: Partial<Sys.Types.FindOptionsWhere<This.GoalSetting>>) { component.var_additionalFilterOptions.set(value) },
                get allCycles() { return component.var_allCycles() },
                set allCycles(value: This.GoalSettingCycle[]) { component.var_allCycles.set(value) },
                get linkToScreen() { return component.var_linkToScreen() },
                set linkToScreen(value: 'Edit' | 'View') { component.var_linkToScreen.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            additionalFilterOptions: this.screen.additionalFilterOptions,
            linkToScreen: this.screen.linkToScreen
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_additionalFilterOptions = this.dialogData?.data?.additionalFilterOptions ?? this.input_additionalFilterOptions() ?? (undefined)
            if (new_additionalFilterOptions !== undefined) this.screen.additionalFilterOptions = new_additionalFilterOptions

            if (!isVariablesInitialized) this.screen.allCycles = ([])

            const new_linkToScreen = this.dialogData?.data?.linkToScreen ?? this.input_linkToScreen() ?? ('View')
            if (new_linkToScreen !== undefined) this.screen.linkToScreen = new_linkToScreen

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    _DataTableBlock_additionalFindOptions_68($scope: any): any {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return ({
            relations: {
                cycle: true,
            },
            where: screen.additionalFilterOptions,
            order: {
                cycle: {
                    startDate: 'desc',
                    id: 'desc',
                },
                employee: {
                    name: 'asc',
                },
            }
        })
    }

    _DataTableColumnBlock_sortAndFilter_79_79($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: Toolbox.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs: Toolbox.GoalSetting) => {
            return (
                gs.id
            )
        }
    }

    _DataTableColumnBlock_cellText_71($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: Toolbox.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs.cycle.getDateRange())
    }

    _DataTableColumnBlock_sortAndFilter_71_71($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: Toolbox.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs: Toolbox.GoalSetting) => {
            return (
                gs.cycle.getDateRange()
            )
        }
    }

    _DataTableColumnBlock_cellText_70($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: Toolbox.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs.employee.name)
    }

    _DataTableColumnBlock_sortAndFilter_70_70($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: Toolbox.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs: Toolbox.GoalSetting) => {
            return (
                gs.employee.name
            )
        }
    }

    _DataTableColumnBlock_cellText_72($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: Toolbox.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs.manager.name)
    }

    _DataTableColumnBlock_sortAndFilter_72_72($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: Toolbox.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs: Toolbox.GoalSetting) => {
            return (
                gs.manager.name
            )
        }
    }

    _DataTableColumnBlock_cellText_69($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: Toolbox.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs.status.label)
    }

    _DataTableColumnBlock_sortAndFilter_69_69($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: Toolbox.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs: Toolbox.GoalSetting) => {
            return (
                gs.status.label
            )
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            screen.allCycles = await This.Db.loadByCondition(This.GoalSettingCycle, {
                order: {
                    startDate: 'desc',
                    id: 'desc',
                }
            })
        }
    }
}
